import ProjectCompanyMobilePage from "./project-company-mobile-page";
export default ProjectCompanyMobilePage;